import { useEffect, useState, useRef } from "react";
import {
  Link as LinkRoute,
  useParams,
  useSearchParams,
} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../component/Pagination";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { toast } from "react-toastify";
import BannerSkeleton from "../../component/skeleton/BannerSkeleton";
import { fetchGoalsCategories } from "../../action/getGoalCategoryAdmin";
import EnableSwitch from "../../component/admin/goalCategories/EnableSwitch";
import { INITIAL_CONFIRM_MODEL } from "../../helper/helper";
import ConfirmModel from "../../component/Modals/ConfirmModel";
import { deleteSvg, editSvg } from "../../assets";
import EditCreateCategory from "../../component/admin/goalCategories/EditCreateCategory";
import { ConstructionOutlined } from "@mui/icons-material";
import SubCategory from "../../component/admin/goalCategories/SubCategory";
import CategoriesRows from "../../component/admin/goalCategories/CategoriesRows";

const goalsColumn = [
  { id: "category_select", label: "category_select", width: "5%" },
  { id: "name", label: "CATEGORY NAME", width: "75%" },
  { id: "enable", label: "ENABLE", width: "5%" },
  // { id: "category_actions", label: "ACTIONS", width: "15%" },
];

export default function Categories() {
  const navigate = useNavigate();
  const goalCategoriesData = useSelector((state) => state.goalCategoriesAdmin);
  const token = useSelector((state) => state.auth.token);
  const [goalsCategories, setGoalsCategories] = useState([]);
  const dispatch = useDispatch();
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);

  const { create, edit, name } = useParams();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const limit = searchParams.get("limit");
  const search = searchParams.get("search");
  const remove = searchParams.get("delete");
  const [isLoading, setIsLoading] = useState(false);
  const [records, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLimit, setCurrentLimit] = useState(2);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [recordFrom, setRecordFrom] = useState(0);
  const [recordTo, setRecordTo] = useState(0);
  const [searchInput, setSearchInput] = useState(search || "");
  const [confirmModel, setConfirmModel] = useState(INITIAL_CONFIRM_MODEL);
  const [editCreateModel, setEditCreateModel] = useState({
    isOpen: false,
    onClose: null,
    onConfirm: () => {},
    onCancel: () => {},
    title: ``,
    description: ``,
    cancelText: `Cancel`,
    confirmText: `Submit`,
    catName: "",
  });

  // current selected for delete modal
  const currentRef = useRef(null);
  // current call back selected for delete modal
  const currentCallback = useRef(null);
  // current custom text
  // const [currentText, setCurrentText] = useState(null);
  const currentTextRef = useRef(null);

  useEffect(() => {
    dispatch(fetchGoalsCategories(token, 1));
  }, [dispatch, token]);

  useEffect(() => {
    if (goalCategoriesData?.data) {
      if (goalCategoriesData?.data?.body?.records?.length > 0) {
        setGoalsCategories(goalCategoriesData?.data?.records);
        setCurrentPage(goalCategoriesData?.data?.pagination?.currentPage);
        setTotalPages(goalCategoriesData?.data?.pagination?.totalPages);
      } else {
        setGoalsCategories("NO Data");
      }
    } else if (!goalCategoriesData?.data?.success) {
      setGoalsCategories(goalCategoriesData?.data?.message);
    }
  }, [goalCategoriesData]);

  const handleChangePage = (event, newPage) => {
    // dispatch(fetchGoalsCategories(token, newPage));
  };

  const handleDeleteBanner = async (ref) => {

    if (ref.current && ref.current?.id) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/deleteLink/${ref.current.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          dispatch(fetchGoalsCategories(token, currentPage));
          toast.success("link deleted successfully");
        }
      } catch (error) {
        toast.error("Please try again..");
      } finally {
        setOpenDelete(false);
      }
    } else {
      toast.error("error!!");
    }
  };

  async function handleMultipleDelete(ref) {
    try {
      const ids = Array.from(ref.current.entries()).map((ele) => ele[0]);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleLinks`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        dispatch(fetchGoalsCategories(token, currentPage));
        toast.success("Selected Banners deleted successfully");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      // setOpenMulitDelete(false);
      setOpenDelete(false);
    }
  }

  useEffect(() => {
    const fetch = async () => {
      dispatch(fetchGoalsCategories(token, page, limit, search));
    };

    if (token) {
      fetch();
    }
  }, [page, limit, search]);

  useEffect(() => {
    if (remove) {
      handleDelete(remove);
    } else {
      setConfirmModel(INITIAL_CONFIRM_MODEL);
    }
  }, [remove]);

  useEffect(() => {
    if (create) {
      setEditCreateModel({
        isOpen: true,
        onClose: handleEditUpdateClose,
        onConfirm: async (name) => {
          setIsLoading(true);
          dispatch({ type: "CREATE_GOAL_CATEGORY_ADMIN_REQUEST" });
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/goal-categories`,
              { name },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response.data?.success) {
              dispatch({
                type: "CREATE_GOAL_CATEGORY_ADMIN_SUCCESS",
                payload: response.data.body,
              });
            }
          } catch (error) {
            dispatch({
              type: "CREATE_GOAL_CATEGORY_ADMIN_FAILURE",
              payload: error.message,
            });
          } finally {
            setIsLoading(false);
            handleEditUpdateClose();
          }
        },
        onCancel: handleEditUpdateClose,
        title: `Create New Category`,
        description: ``,
        cancelText: `Cancel`,
        confirmText: `Create`,
        catName: "",
      });
    } else {
      setEditCreateModel({
        isOpen: false,
        onClose: null,
        onConfirm: () => {},
        onCancel: () => {},
        title: ``,
        description: ``,
        cancelText: `Cancel`,
        confirmText: `Submit`,
        catName: "",
      });
    }
  }, [create]);

  useEffect(() => {
    if (edit && name) {
      setEditCreateModel({
        isOpen: true,
        onClose: handleEditUpdateClose,
        onConfirm: async (name) => {
          setIsLoading(true);
          dispatch({ type: "UPDATE_GOAL_CATEGORY_ADMIN_REQUEST" });
          try {
            const response = await axios.put(
              `${process.env.REACT_APP_API_URL}/goal-categories`,
              { id: edit, name },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response.data?.success) {
              dispatch({
                type: "UPDATE_GOAL_CATEGORY_ADMIN_SUCCESS",
                payload: response.data.body,
              });
            }
          } catch (error) {
            dispatch({
              type: "UPDATE_GOAL_CATEGORY_ADMIN_FAILURE",
              payload: error.message,
            });
          } finally {
            setIsLoading(false);
            handleEditUpdateClose();
          }
        },
        onCancel: handleEditUpdateClose,
        title: `Update Category`,
        description: ``,
        cancelText: `Cancel`,
        confirmText: `Update`,
        catName: name,
      });
    } else {
      setEditCreateModel({
        isOpen: false,
        onClose: null,
        onConfirm: () => {},
        onCancel: () => {},
        title: ``,
        description: ``,
        cancelText: `Cancel`,
        confirmText: `Submit`,
        catName: "",
      });
    }
  }, [edit]);

  useEffect(() => {
    if (goalCategoriesData?.data?.records?.length) {
      const { records, pagination } = goalCategoriesData?.data;
      setData(records || []);
      setCurrentPage(pagination?.page || 1);
      setCurrentLimit(pagination?.limit || 10);
      setTotalPages(pagination?.totalPages || 1);
      setTotalRecords(pagination?.totalRecords || 0);
      setRecordFrom(pagination?.recordFrom || 0);
      setRecordTo(pagination?.recordTo || 0);
    } else {
      setData("NO Data");
    }
  }, [goalCategoriesData]);

  const handleEditUpdateClose = () => {
    setEditCreateModel({
      isOpen: false,
      onClose: null,
      onConfirm: () => {},
      onCancel: () => {},
      title: ``,
      description: ``,
      cancelText: `Cancel`,
      confirmText: `Submit`,
      catName: "",
    });
    navigate("/admin/dashboard/goal-categories");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(createPaginationUrl(1, searchInput, limit));
  };

  const createPaginationUrl = (newPage, search, limit) => {
    const params = new URLSearchParams();
    if (newPage) {
      params.set("page", newPage.toString());
    }
    if (search) {
      params.set("search", search);
    }
    if (limit) {
      params.set("limit", limit.toString());
    }
    return params.toString() ? `?${params.toString()}` : "";
  };

  const handleDelete = (id) => {
    setConfirmModel({
      isOpen: true,
      title: "Delete Goal Category",
      description: `Are you sure you want delete this? This action can't be undone.`,
      onConfirm: async () => {
        setIsLoading(true);
        dispatch({ type: "DELETE_GOAL_CATEGORY_ADMIN_REQUEST" });
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_API_URL}/goal-categories`,
            {
              params: { id },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.data?.success) {
            dispatch({
              type: "DELETE_GOAL_CATEGORY_ADMIN_SUCCESS",
              payload: response.data.body,
            });
            toast.success("Category deleted successfully.");
          }
        } catch (error) {
          dispatch({
            type: "DELETE_GOAL_CATEGORY_ADMIN_FAILURE",
            payload: error.message,
          });
          toast.error(error.message || "Failed to delete category!");
          console.error("Error in handleDelete : ", error.message);
        } finally {
          setIsLoading(false);
          setConfirmModel(INITIAL_CONFIRM_MODEL);
          navigate(`/admin/dashboard/goal-categories`);
        }
      },
      onCancel: () => {
        setConfirmModel(INITIAL_CONFIRM_MODEL);
        navigate(`/admin/dashboard/goal-categories`);
      },
      cancelText: `Cancel`,
      confirmText: `Confirm`,
    });
  };


  return (
    <>
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading ?? false}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Box className="page_title custom-header">
        <Typography variant="h1" component="h1">
          Goal Categories
        </Typography>
      </Box>
      <Box className="page_inner">
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "700px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id !== "category_select" ? (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        {column.label}
                      </TableCell>
                    ) : null
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(records) && records.length > 0 ? (
                  records.map((value, index) => (
                    <>
                      {/* <TableRow key={index}>
                        <TableCell>
                          <Box className="property_name">
                            <Box className="td-wrapper">
                              <Typography
                                variant="p"
                                component="p"
                                className="table-text"
                              >
                                {value?.name}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Box className="td-wrapper">
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text"
                            >
                              <EnableSwitch
                                value={value}
                                api={`goal-categories`}
                              />
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                      {value?.subCategory?.length > 0 ? (
                        <SubCategory
                          subCategory={value.subCategory}
                          index={`sub-${index}`}
                        />
                      ) : null} */}
                      <CategoriesRows category={value} index={index} />
                    </>
                  ))
                ) : records !== "NO Data" ? (
                  Array.from({ length: 10 }).map((_e, i) => (
                    <BannerSkeleton key={i} />
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {records}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* custom delete modal */}
      <ConfirmModel {...confirmModel} />
      <EditCreateCategory {...editCreateModel} />
    </>
  );
}
